import { useSyncExternalStore } from "react";

/**
 * One shared clock for every relative time on screen. Subscribers re-render when the 30-second
 * bucket changes, so "2m ago" keeps moving without a timer per component. The interval runs only
 * while something is subscribed.
 */
const TICK_MS = 30_000;
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (timer === null) timer = setInterval(() => { for (const l of listeners) l(); }, TICK_MS);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) { clearInterval(timer); timer = null; }
  };
}
const bucket = () => Math.floor(Date.now() / TICK_MS);

/** The current 30-second bucket; use it to re-render, and read `new Date()` for the value. */
export function useNowTick(): number {
  return useSyncExternalStore(subscribe, bucket, bucket);
}
